const point = "https://central-backend.cuba-lv.com"
const startpoint = `${point}/admin/`
const mediapoint = `${point}/`
const gamepoint = `${point}/`
const socketpoint = `${point}`

const bridgeURL = "https://game-bridge.cuba-lv.com/"

const livekit = "wss://livekit-edge.cuba-lv.com"
const livekitService = "https://livekit-edge-service.cuba-lv.com"
const LIVEKIT_TOKEN = "41ccaca0-d349-4a1d-9e9a-6ca52e878f53"

export { point, startpoint, gamepoint, mediapoint, socketpoint, bridgeURL, livekit, livekitService, LIVEKIT_TOKEN }
